export const pagingButtonFunc = (onChangePageFunc) => {
  // ページングボタンにそれぞれonclickを登録
  const pagingItems = document.querySelectorAll('.js-pagination-item');
  pagingItems.forEach((element) => {
    element.addEventListener('click', () => {
      onChangePageFunc(element.getAttribute('page'));
    });
  });
};
